import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const ImageCompressionTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader tabName={t('pageIntegrations.tabNames.image-compression')} />
      <IntegrationsTable category={IntegrationCategory.IMAGE_COMPRESSION} />
    </section>
  );
};

export default ImageCompressionTab;
